export const MEMBER_WELCOME_WIZARD_STEP_IDS = [
  'avatar',
  'banner',
  'social',
  'story',
  'topics',
] as const;

export type MemberWelcomeWizardStepId = (typeof MEMBER_WELCOME_WIZARD_STEP_IDS)[number];

export function isMemberWelcomeWizardStepId(value: string): value is MemberWelcomeWizardStepId {
  return (MEMBER_WELCOME_WIZARD_STEP_IDS as readonly string[]).includes(value);
}

export function resolveMemberWelcomeWizardStepIndex(step: string | null | undefined): number {
  if (!step || !isMemberWelcomeWizardStepId(step)) return 0;
  const index = MEMBER_WELCOME_WIZARD_STEP_IDS.indexOf(step);
  return index >= 0 ? index : 0;
}
